import { Component } from '@angular/core';
import { LocaleService } from '@tdwb/core';
import { AgreementsBase } from '../agreements.base';

// eslint-disable-next-line td-wb-rules/change-detection-strategy-rule
@Component({
  selector: 'td-wb-old-amex-nyse',
  templateUrl: './old-amex-nyse.component.html',
  styleUrls: ['../agreements.component.scss'],
  standalone: false
})
export class OldAmexNyseComponent extends AgreementsBase {
  constructor(localeService: LocaleService) {
    super(localeService);
  }
}
